// src/context/RegionContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../services/api";
import { useAuth } from "./AuthContext";

// Create Context
const RegionContext = createContext();

// Provider Component
export const RegionProvider = ({ children }) => {
  const [regions, setRegions] = useState([]);
  const { isAuthenticated, authVersion } = useAuth();

  // Fetch regions from API
  const fetchRegions = async () => {
    try {
      const response = await api.get("/Regions");
      setRegions(response.data);
    } catch (error) {}
  };

  // Fetch when user is authenticated (and re-fetch after login)
  useEffect(() => {
    if (isAuthenticated) {
      fetchRegions();
    }
  }, [isAuthenticated, authVersion]);

  return (
    <RegionContext.Provider value={{ regions }}>
      {children}
    </RegionContext.Provider>
  );
};

// Custom hook
export const useRegions = () => {
  const { regions } = useContext(RegionContext);
  return regions;
};
